import { useNuxtApp } from '#app'

const appType = 'react-mall-app'

export function behaviorRecord(data) {
  return useNuxtApp().$customFetch('../collectionSite/mall/frontserver/behavior/record', {
    method: 'POST',
    body: { ...(data || {}), appType: (data && data.appType) || appType },
  })
}
